<template>
    <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element">
        {{copyrightLabel}}
    </div>
</template>

<script>
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";

    export default {
        name: "CopyrightComponent",
        mixins: [AnimationsMixin],
        data () {
          return {
              componentType: "copyright",
              rendersWithVue: true
          }
        },
        computed: {
            copyrightLabel () {
                return "Copyright ©" + new Date().getFullYear();
            }
        }
    }
</script>

